import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as EntitiesActionTypes from '../../entities/actionTypes'
import {filterMapByKeys} from '../../atUtils'

const initialState = {
    existingTaskIdsByFilters: {},
    existingTaskIdsLoading: false,
    existingTaskIdsLoaded: false,
    selectedTaskIds: {},
    pendingSelectAll: false,
}

export default handleActions({
    [ActionTypes.SELECTED_TASK_IDS_CHANGE]: (state, {payload: selectedTaskIds}) => ({
        ...state,
        selectedTaskIds,
    }),
    [ActionTypes.LOAD_EXISTING_TASK_IDS]: state => ({
        ...state,
        existingTaskIdsLoading: true,
    }),
    [ActionTypes.LOAD_EXISTING_TASK_IDS_SUCCESS]: (state, {payload: ids}) => ({
        ...state,
        existingTaskIdsByFilters: ids,
        existingTaskIdsLoading: false,
        existingTaskIdsLoaded: true,
    }),
    [ActionTypes.LOAD_EXISTING_TASK_IDS_FAILURE]: state => ({
        ...state,
        existingTaskIdsLoading: false,
    }),
    [ActionTypes.PENDING_SELECT_ALL_SET]: (state, {payload: preselectedIds}) => ({
        ...state,
        pendingSelectAll: true,
        selectedTaskIds: preselectedIds,
    }),
    [ActionTypes.PENDING_SELECT_ALL_RESET]: state => ({
        ...state,
        pendingSelectAll: false,
    }),
    [ActionTypes.EXISTING_TASK_IDS_BY_FILTERS_SET]: (state, {payload: ids}) => ({
        ...state,
        existingTaskIdsByFilters: ids
    }),
    [ActionTypes.EXISTING_TASK_IDS_LOADED_RESET]: (state) => ({
        ...state,
        existingTaskIdsLoaded: false,
        existingTaskIdsLoading: false,
    }),
    [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: ids}) => {
        return {
            ...state,
            existingTaskIdsByFilters: filterMapByKeys(state.existingTaskIdsByFilters, ids),
            selectedTaskIds: filterMapByKeys(state.selectedTaskIds, ids),
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./web/js/taskManagement/taskSelection/reducer.js